import React, {Component,Fragment} from 'react';
import {observer} from "mobx-react";
import {toJS} from "mobx";
import reactionCombinerOb from "../../utils/reactionCombiner";
import moment from "moment";
import {IMaskInput} from 'react-imask';
import IMask from 'imask';
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";

const reactionCombiner=new reactionCombinerOb();

class DateField extends Component {
  constructor(props) {
    super(props);
    this._onWindowClick=(e)=>{
      let inside=false;
      e.composedPath().forEach((item)=>{
        if(item.classList && (item.classList.contains("rdtPicker") || item.classList.contains("formyInputForPicker"))) {
          inside=true;
        }
      });

      console.log("win click", inside);
      if(!inside && this._pickerRef) {
        this._pickerRef._closeCalendar();
      }

    };
  }
  componentWillUnmount() {
    document.removeEventListener("click", this._onWindowClick);
  }

  componentDidMount() {
    document.addEventListener("click",this._onWindowClick);

    reactionCombiner.addReaction(()=>{
      return this.props.linker.value;
    },()=>{
      if(moment(toJS(this.props.linker.value), "DD.MM.YYYY", true).isValid()) {
        if(this._pickerRef) {
          this._pickerRef._closeCalendar();
        }
      }
    })
  }
  getInputPattern() {
    return this.props.use_time?'d.m.Y h:i:s':'d.m.Y';
  }
  renderInput(props, showCalendar, closeCalendar) {
    const onChange=props.onChange
    const blocks={
      d: {mask: IMask.MaskedRange, placeholderChar: '_', from: 1, to: 31, maxLength: 2},
      m: {mask: IMask.MaskedRange, placeholderChar: '_', from: 1, to: 12, maxLength: 2},
      Y: {mask: IMask.MaskedRange, placeholderChar: '_', from: 1000, to: 2999, maxLength: 4},

    };

    if(this.props.use_time) {
      blocks.h = {mask: IMask.MaskedRange, placeholderChar: '_', from: 0, to: 23, maxLength: 2};
      blocks.i = {mask: IMask.MaskedRange, placeholderChar: '_', from: 0, to: 59, maxLength: 2};
      blocks.s = {mask: IMask.MaskedRange, placeholderChar: '_', from: 0, to: 59, maxLength: 2};
    }


    return (
      <IMaskInput
        inputRef={(ref)=>{ if(this.props.inputRef) { this.props.inputRef(ref); } }}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        mask={Date}
        pattern={this.getInputPattern()}
        className="w100 formyInputForPicker formiyInput"
        disabled={this.props.disabled}
        blocks={blocks}
        lazy={false}
        type="text"
        overwrite={true}
        value={this.props.linker.value}
        unmask={false} // true|false|'typed'
        format={(date)=> {
          let day = date.getDate();
          let month = date.getMonth() + 1;
          let year = date.getFullYear();
          let hour = date.getHours();
          let minutes = date.getMinutes();
          let seconds = date.getSeconds();

          if (day < 10) day = "0" + day;
          if (month < 10) month = "0" + month;
          if (hour < 10) hour = "0" + hour;
          if (minutes < 10) minutes = "0" + minutes;
          if (seconds < 10) seconds = "0" + seconds;
          if(this.props.use_time) {
            return `${day}.${month}.${year} ${hour}:${minutes}:${seconds}`;
          } else {
            return `${day}.${month}.${year}`;
          }
        }}
        parse={(str)=>{
          const dt=str.split(' ');
          const dateParts=dt[0].split('.');

          if(this.props.use_time) {
            const timeParts=dt[1].split(':');
            return new Date(parseInt(dateParts[2]), parseInt(dateParts[1])-1, parseInt(dateParts[0]), parseInt(timeParts[0]), parseInt(timeParts[1]), parseInt(timeParts[2]));
          } else {
            return new Date(parseInt(dateParts[2]), parseInt(dateParts[1])-1, parseInt(dateParts[0]));
          }
        }}
        onAccept={
          (value, mask) => {
            this.props.linker.value = value;
            if(value.indexOf("_")===-1) {
              const time=moment(value, this.getFullStrFormat());
              this.props.saveValueLinker.value=time.format(this.getFullDbFormat())
            } else {
              this.props.saveValueLinker.value="";
            }

            /*if(value.match(/[0-9]+/gi)) {
              this.props.linker.value = value;
            } else {
              this.props.linker.value="";
            }*/
          }
        }
      />
    );
  }
  getFullDbFormat() {
    return this.props.use_time?"YYYY-MM-DD HH:mm:ss":"YYYY-MM-DD";
  }
  getFullStrFormat() {
    return this.props.use_time?"DD.MM.YYYY HH:mm:ss":"DD.MM.YYYY"
  }
  dateChanged(newValue) {
    if (typeof newValue === "string") {
      this.props.linker.value=newValue;
      this.props.saveValueLinker.value="";
    } else {
      this.props.linker.value=newValue.format(this.props.use_time?"DD.MM.YYYY HH:mm:ss":"DD.MM.YYYY");
      this.props.saveValueLinker.value=newValue.format(this.props.use_time?"YYYY-MM-DD HH:mm:ss":"YYYY-MM-DD");
    }
  }
  addClearTable(ref) {
    if(ref) {
      const allTables = ref.querySelectorAll("table");
      for (let i in allTables) {
        if(allTables[i].classList) {
          if (!allTables[i].classList.contains("clear")) {
            allTables[i].classList.add("clear");
          }
        }
      }
    }
  }
  render() {
    return (
      <Datetime
        ref={(ref)=>{ this._pickerRef=ref; }}
        closeOnClickOutside={false}
        closeOnSelect={this.props.use_time?false:true}
        onChange={(newValue)=>{ this.dateChanged(newValue); }}
        value={this.props.linker.value}
        timeFormat={this.props.use_time?"HH:mm:ss":false}
        dateFormat={"DD.MM.YYYY"}
        renderInput={this.renderInput.bind(this)}
        renderView={(mode, renderDefault)=>{
          return (
            <div className="datePickerFullWrap" ref={(ref)=>{ this.addClearTable(ref); }}>
              {renderDefault()}
            </div>
          )
        }}

      />
    )
  }
}

export default observer(DateField);